const routes = {
    home: '/',
    search: '/search',
    login: '/login',
    signin: '/signin',
    hotlist: '/hot-list',
    bxh: '/bxh',
    album: '/album',
    video: '/video',
    artist: '/artist',
    artists: '/artists',
    vip: '/music-vip',
    player: '/player',
    albums: '/albums',
};

export default routes;
